import React from "react"
import Layout from "../utils/layout"
import Structure from "../components/scenes/Structure/Structure"

export default () => (
  <Layout>
    <Structure />
  </Layout>
)
